import * as React from "react";
import { CertificateResource } from "../../../stores/CoursesStore/Types";
import { Link } from "react-router-dom";

interface Props {
  course: CertificateResource;
  idx: number;
}

const CertificateImage: React.FC<Props> = ({ course, idx }) => {
  if (course.enrolment_id && course.passed) {
    return (
      <Link
        to={`/enrolments/${course.enrolment_id}/certificate`}
        className="cert-tile is-earned"
      >
        <span className="cert-art">
          <img
            src={course.preview_image}
            alt={course.name}
            className={`certificate certificate${idx}`}
          />
        </span>
        <span className="cert-course">{course.name}</span>
      </Link>
    );
  } else {
    return (
      <span className="cert-tile is-locked" aria-disabled="true">
        <span className="cert-art">
          <img
            src={course.preview_image}
            alt={course.name}
            className={`certificate certificate${idx} ui image disabled`}
          />
        </span>
        <span className="cert-course">{course.name}</span>
      </span>
    );
  }
};

export default CertificateImage;
